import React, { lazy } from 'react';
interface BonusCardProps {
  number: number;
  title: string;
  description: string;
  imageUrl?: string;
  fallbackEmoji?: string;
}
export function BonusCard({
  number,
  title,
  description,
  imageUrl,
  fallbackEmoji
}: BonusCardProps) {
  const scrollToCompra = () => {
    window.open('https://pay.hotmart.com/R105070415Y?checkoutMode=10', '_blank');
  };
  return <div className="bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden hover:shadow-xl transition-shadow duration-300" data-id="element-1">
      {imageUrl ? <button onClick={scrollToCompra} className="w-full cursor-pointer block" data-id="element-2">
          <img src={imageUrl} alt={title} className="w-full aspect-square object-cover" loading="lazy" decoding="async" width={1080} height={1080} data-id="element-3" />
        </button> : <button onClick={scrollToCompra} className="w-full cursor-pointer block" data-id="element-4">
          <div className="w-full aspect-square bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex flex-col items-center justify-center p-8 border-b-4 border-amber-500" data-id="element-5">
            <span className="text-6xl mb-4" data-id="element-6">{fallbackEmoji || '🔥'}</span>
            <p className="font-heading text-amber-400 text-2xl font-bold text-center uppercase" data-id="element-7">
              {title}
            </p>
          </div>
        </button>}
      <div className="p-5" data-id="element-8">
        <span className="inline-block bg-amber-500 text-black text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide mb-3" data-id="element-9">
          🎁 Bono #{number}
        </span>
        <h3 className="font-heading text-lg md:text-xl font-bold text-gray-900 mb-2" data-id="element-10">
          {title}
        </h3>
        <p className="text-gray-600 text-sm mb-4" data-id="element-11">{description}</p>
        <div className="flex items-center gap-3" data-id="element-12">
          <span className="text-red-500 line-through text-sm font-semibold" data-id="element-13">
            Valor: USD $5
          </span>
          <span className="bg-green-500 text-white text-sm font-bold px-3 py-1 rounded-full" data-id="element-14">
            HOY: GRATIS
          </span>
        </div>
      </div>
    </div>;
}